import { useMutation, gql } from '@apollo/client';

import {
  AlocarProfessorMutation,
  AlocarProfessorMutationVariables,
} from './__generated__/AlocarProfessorMutation';

const ALOCAR_PROFESSOR_MUTATION = gql`
  mutation AlocarProfessorMutation(
    $id_professor: Int!
    $id_horario: Int!
    $id_oferta: Int!
    $id_turma: Int!
    $id_disciplina: Int!
    $dat_alocacao: String!
    $planejamento: Boolean!
    $ind_status: Int
  ) {
    alocarProfessor(
      input: {
        id_professor: $id_professor
        id_horario: $id_horario
        id_oferta: $id_oferta
        id_turma: $id_turma
        id_disciplina: $id_disciplina
        dat_alocacao: $dat_alocacao
        ind_status: $ind_status
        planejamento: $planejamento
      }
    ) {
      id_alocacao
      id_oferta
      id_turma
      dat_alocacao
      ind_status
      planejamento
      disciplina {
        id_disciplina
        dsc_sigla
        num_carga_horaria
      }
      professor {
        id_professor
        dsc_nome_professor
      }
    }
  }
`;

const useAlocarProfessorMutation = () => {
  return useMutation<AlocarProfessorMutation, AlocarProfessorMutationVariables>(
    ALOCAR_PROFESSOR_MUTATION
  );
};

export { useAlocarProfessorMutation };
